import { Box, Grid } from 'deepstash-ui';
import React from 'react';
import { GAP_SIZE_REM } from 'utils/global';

interface OwnProps {
  items: any;
  displayGrid?: boolean;
  sideBySide?: boolean;
}

const ScrollWrapperOriginal: React.FC<OwnProps> = ({
  items,
  displayGrid,
  sideBySide,
}) => {
  return sideBySide ? (
    <Grid
      gridTemplateColumns={{ base: 'repeat(1, 1fr)', lg: 'repeat(2, 1fr)' }}
      ml="0"
      style={style.gridContainerStyle}
      gridGap={GAP_SIZE_REM}
    >
      {items}
    </Grid>
  ) : displayGrid ? (
    <Grid
      gridTemplateColumns={{ base: 'repeat(1, 1fr)', lg: 'repeat(3, 1fr)' }}
      ml={{ base: '0', lg: '-10px' }}
      style={style.gridContainerStyle}
    >
      {items}
    </Grid>
  ) : (
    <Box style={style.listContainerStyle}>{items}</Box>
  );
};

const style: Record<string, React.CSSProperties> = {
  listContainerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  gridContainerStyle: {
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export default ScrollWrapperOriginal;
